import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Hero } from "@/components/sections/Hero";
import { Situazione } from "@/components/sections/Situazione";
import { Servizi } from "@/components/sections/Servizi";
import { Percorsi } from "@/components/sections/Percorsi";
import { Calcolatore } from "@/components/sections/Calcolatore";
import { GestioneAssistita } from "@/components/sections/GestioneAssistita";
import { Metodo } from "@/components/sections/Metodo";
import { Strutture } from "@/components/sections/Strutture";
import { PerChi } from "@/components/sections/PerChi";
import { Statement } from "@/components/sections/Statement";
import { BusinessPlan } from "@/components/sections/BusinessPlan";
import { ChiSiamo } from "@/components/sections/ChiSiamo";
import { Contatti } from "@/components/sections/Contatti";
import { useReveal } from "@/hooks/useReveal";

export default function LandingPage() {
  const location = useLocation();
  useReveal();
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ block: "start" }), 150);
    }
  }, [location.hash]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Situazione />
        <Servizi />
        <Percorsi />
        <Calcolatore />
        <GestioneAssistita />
        <Metodo />
        <Strutture />
        <PerChi />
        <Statement />
        <BusinessPlan />
        <ChiSiamo />
        <Contatti />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}
